import { VHeaders } from '@/models/pagedlistmodel';

export function getTenantListHeaders(vm: any): VHeaders[] {
  return [
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('tenants.tenantGridHeaders.name') as string,
      value: 'name',
    },
    {
      align: 'left',
      sortable: true,
      text: vm.$parent.$t('tenants.tenantGridHeaders.code') as string,
      value: 'code',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t('tenants.tenantGridHeaders.action') as string,
      sortable: false,
    },
  ];
}
